var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data3)?_c('div',{ref:"main3",staticStyle:{"width":"100%"},attrs:{"id":"main3"}}):_c('no-data-temporarily',{staticStyle:{"width":"100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }